import React, { useState, useEffect } from "react"
import { Space } from "antd"

const Card = ({ info }) => {
  return (
    <>
      <div className="card-link">
        {info.link ? (
          <a href={info.link} target="_blank">
            <div
              style={{
                padding: "30px",
              }}
            >
              <Space style={{
                width: "100%",
              }}>
                <img src={info.icon} />
                <div className="card-title-font">{info?.title}</div>
              </Space>
              <div className="text-font" style={{ textAlign: "left", marginTop: 10 }}>
                <p>{info?.text}</p>
              </div>
            </div>
          </a>
        ) : (
          <div
            style={{
              padding: "30px",
            }}
          >
            <Space style={{
              width: "100%",
            }}>
              <img src={info.icon} />
              <div className="card-title-font">{info.title}</div>
            </Space>
            <div className="text-font" style={{ textAlign: "left", marginTop: 10 }}>
              <p>{info.text}</p>
            </div>
          </div>
        )}

      </div>
    </>
  )
}

export default Card
